import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums';

/**
 * INT-1702 (KTD7): channels whose reactions the chat shows. Reacting from
 * Leadsales stays WhatsApp API only; Messenger and Instagram are read-only.
 */
const REACTION_VIEW_CHANNELS: ReadonlySet<string> = new Set([
  eChannelType.WHATSAPP_API,
  eChannelType.MESSENGER,
  eChannelType.INSTAGRAM,
  eChannelType.TIKTOK,
]);

export function canViewReactionsOn(channel: string | undefined): boolean {
  return Boolean(channel) && REACTION_VIEW_CHANNELS.has(channel as string);
}
